import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// Plus Jakarta Sans and Instrument Serif arrive with the @nexford/ui global layer (app.scss). DM Mono is the
// kit redesign's mono face, at the weights it loads.
import '@fontsource/dm-mono/300.css';
import '@fontsource/dm-mono/400.css';
import '@fontsource/dm-mono/500.css';
import './tailwind.css';
import './app.scss';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
